<template>
  <div id="search" class="sav-wrapper">
    <Spinner v-if="isLoading"/>
    <Topbar/>
    <div class="sav-container">
        <Header :title="headerTitle" search="true"/>

        <div class="sav-search">
            <div class="flex flex-wrap">
                <div class="input-container">
                    <h3>Στοιχεία Ασφαλιζόμενου</h3>
                    <input v-on:keyup.enter="onSearchHandler" class="flex-1" type="text" v-model="searchDetailsQuery" :placeholder="searchDetailsPlaceholder">
                </div>
                <div class="input-container">
                    <h3>Περιοχή</h3>
                    <input v-on:keyup.enter="onSearchHandler" class="flex-1" type="text" v-model="searchRegionQuery" :placeholder="searchRegionPlaceholder">
                </div>
            </div>
            <div class="sav-search-footer">
                <div v-if="errorMsg" id="error-msg" class="flex flex-align-items-center">
                    <b>{{ errorMsg }}</b>
                </div>
                <div v-if="resultNum" id="results-num-msg" class="flex flex-align-items-end">
                    <b>{{ resultNum }}</b>
                </div>
                <button @click="onSearchHandler" type="submit" class="sav-btn sav-btn-red">Αναζήτηση</button>
            </div>
        </div>

        <hr v-if="tableRows">

        <Table v-if="tableRows" category="search" :tableHeaders="tableHeaders" :tableRows="tableRows"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './Spinner.vue'
import Topbar from './Topbar.vue'
import Header from './Header.vue'
import Table from './Table.vue'
import overviewHeaders from './../../public/data/db.overview-headers.json'

export default {
  components: {
    Spinner,
    Topbar,
    Header,
    Table
  },
  data() {
    return {
        isLoading: true,
        apiUrl : this.$parent.apiUrl,
        headerTitle: 'Αναζήτηση Ασφαλειών',
        searchDetailsPlaceholder: 'Όνομα ή ΑΦΜ ή Πινακίδα ή Τηλέφωνο',
        searchRegionPlaceholder: 'Περιοχή',
        searchDetailsQuery: '',
        searchRegionQuery: '',
        tableHeaders: overviewHeaders,
        tableRows: '',
        errorMsg: '',
        resultNum: ''
    }
  },
  methods : {
    async onSearchHandler () {
        this.resultNum = ''
        this.errorMsg = ''

        if (!this.searchDetailsQuery && !this.searchRegionQuery) {
            this.errorMsg = 'Παρακαλώ εισάγετε πληροφορίες στα παραπάνω πεδία.'
            return
        }

        this.isLoading = true

        this.tableRows = ''
        let formData = {
            searchDetails: this.searchDetailsQuery,
            searchRegion: this.searchRegionQuery,
            user: JSON.parse(localStorage.getItem('sav-erp-user')),
            token: this.$cookie.get('sav-erp-token'),
            refreshToken: this.$cookie.get('sav-erp-refresh-token')
        };

        let headers = { 
            headers: {
                'Content-type': 'application/json',
            }
        };
        
        try {
            const res = await axios.post(this.apiUrl + '/get/search', formData, headers)
            if (res.status == 200) {
                this.$cookie.set('sav-erp-token', res.data.token, { expires: '15m' });
                this.tableRows = res.data.data;
                console.log(this.tableRows)
                this.resultNum = this.getResultHeader(this.tableRows.length);
            } else {
                this.errorMsg = res.data
                    ? res.data
                    : res.status + " - " + res.statusText;
            }
            this.isLoading = false;
        } catch (error) {
            let response = error.response;
            
            if (!response) {
                this.errorMsg = "Μη ενεργός server";
            } else {
                if (response.status == 401) {
                    localStorage.removeItem('user');    
                    this.$cookie.delete('sav-erp-token');
                    this.$cookie.delete('sav-erp-refresh-token');
                    this.$router.push("/login");
                } else {
                    this.errorMsg = response.data
                        ? response.data
                        : response.status + " - " + response.statusText;
                }
            }
            this.isLoading = false;
        }
    },
    getResultHeader (length) {
        return length > 1 ? "Βρέθηκαν " + length + " ασφάλειες." :  "Βρέθηκε 1 ασφάλεια."
    },
  },
  mounted () {
    this.isLoading = false
  }
}
</script>

<style lang="scss" scoped>

@import "./../scss/_colors";
	@import "./../scss/_mq";

	.sav-search {
		margin-bottom: 30px;
	}
	
	.input-container {
		flex: 1;
		margin-bottom: 30px;

		&:not(:last-child) {
            margin-right: 20px;
        }

		h3 {
			margin-top: 0;
			color: $blue;
			border-bottom: 2px solid $blue;
			font-size: 20px;
			font-weight: 500;
			margin-bottom: 15px;
		}
	}
	
	.sav-search-footer {
		display: flex;
		justify-content: flex-end;
	}

	#error-msg {
		color: $red;
		font-weight: 400;
		padding: 10px;
		margin-right: 10px;
	}

	#results-num-msg {
		color: $blue;
		font-weight: 400;
		padding: 10px;
		margin-right: 10px;
	}
</style>
